import React, { useEffect, useMemo, useState } from "react";
import Table from "../../../components/Tables/Schedule";
import { headerMaker } from "../../../components/Tables/Schedule/helper";
import Spinner from "../../../components/Spinner";
import { usePaginate } from "hooks/usePaginate";
import { paymentsHeader } from "redux/modules/table/common";
import {
  Wrapper,
  Title,
  FilterContainer,
  FilterItem,
  PageHeader,
} from "./style";
import Select from "components/FormElements/Select";
import { Button } from "antd";
import { useSelector } from "react-redux";
import service from "../../../services/reports";
import DownloadToExcell from "components/DownloadToExcell";
import moment from "moment";

const statusChecker = (value) => {
  let bg = "";
  let color = "";
  const today = moment(moment(), "YYYY-MM-DD");

  if (value) {
    const date2 = moment(value, "YYYY-MM-DD");
    if (date2.isBefore(today)) {
      bg = "transparent";
      color = "#f00";
    } else if (date2.isAfter(today)) {
      bg = "transparent";
      color = "#1d6f42";
    } else {
      bg = "transparent";
      color = "#1d6f42";
    }
  }

  return {
    bg,
    color,
  };
};

export default () => {
  const { data, handleOnTableChange, pageCount } = usePaginate();
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [postData, setPostData] = useState({});
  const { groups } = useSelector((state) => state.appReducer);
  const headers = useMemo(() => headerMaker(paymentsHeader), [paymentsHeader]);

  const fetchReport = async () => {
    if (Object.keys(postData).length === 0) {
      postData["group"] = groups[0]?._id;
    }
    try {
      setLoading(true);
      const payload = {
        // date: `${singleDate} ${postData.time}`,
        category: postData.category,
        subCategory: postData.subCategory,
        group: postData.group,
      };
      const resp = await service.getUserReportByPayment(payload);
      const result = resp.map((item) => ({
        ...item,
        user_name: `${item.lastName} ${item.firstName} ${item.middleName}`,
        region: item?.region?.title,
        object: item?.object?.title ?? "-",
        logged: {
          value: item?.logged ? "Тиизимга уланган" : "Тиизимга уланмаган",
          bg: "trasnparent",
          color: item?.logged ? "#1d6f42" : "#f00",
        },
        endDate: {
          value: item?.endDate,
          ...statusChecker(item?.endDate),
        },
      }));
      setReportData(result);
      setLoading(false);
    } catch (error) {
      setReportData([]);
      setLoading(false);
      console.log(error);
    }
  };
  useEffect(() => {
    fetchReport();
  }, [postData["group"]]);

  if (loading) return <Spinner maxHeight='100%' />;
  return (
    <Wrapper>
      <PageHeader>
        <Title>Рўйхат</Title>
        <DownloadToExcell
          fileName={"Тўловлар рўйхати"}
          tableName={"payments"}
          tableHeader={headers}
          tableData={reportData}
        />
      </PageHeader>
      <FilterContainer>
        <FilterItem>
          <Select
            handleChange={(value) => {
              setPostData({ ...postData, ["group"]: value });
            }}
            name='group'
            options={groups}
            defaultVal={postData?.group}
            title='Гуруҳ'
          />
        </FilterItem>
      </FilterContainer>
      <Table
        headers={headers}
        data={data}
        onChange={handleOnTableChange}
        page={pageCount}
        reportsData={reportData}
        total={reportData.length}
      />
    </Wrapper>
  );
};
